import { Injectable } from "@nestjs/common";
import { EmployeeTeamDto } from "./dto/employee-team.dto";
import { EmployeeTeamEntity } from "./entity/employee-team.entity";

@Injectable()
export class EmployeeTeamAdapter{
    public convertDtoToEntity(dto:EmployeeTeamDto , isUpdate:boolean = false): EmployeeTeamEntity{
        const entity = new EmployeeTeamEntity()
        entity.id = dto.id;
        entity.employeeCode = dto.employeeCode;
        entity.employeeName = dto.employeeName;
        entity.shiftCode = dto.shiftCode;
        entity.workStationTeam = dto.workStationTeam;
        entity.updatedUser=dto.updatedUser;
        entity.updatedAt=dto.updatedAt;
        entity.createdUser=dto.createdUser;
        entity.isActive = dto.isActive === undefined ? true : dto.isActive;
        if(isUpdate){

            entity.isActive = true;
             }
        return entity;
    }

    public convertEntityToDto(entity:EmployeeTeamEntity):EmployeeTeamDto{
        const dto = new EmployeeTeamDto();
        dto.id = entity.id;
        dto.employeeCode = entity.employeeCode;
        dto.employeeName = entity.employeeName;
        dto.workStationTeam = entity.workStationTeam;
        dto.shiftCode = entity.shiftCode;
        dto.isActive = entity.isActive;
        dto.createdAt = entity.createdAt;
        dto.createdUser = entity.createdUser;
        dto.updatedAt = entity.updatedAt;
        dto.updatedUser = entity.updatedUser;
        dto.versionFlag = entity.versionFlag;
        return dto;

    }
}